import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { LockIconProps as Props } from './types';

export const LockIcon = memo(({ className, sx }: Props) => {
  return (
    <Box className={classnames('LockIcon', className)} sx={SX.root}>
      <Icon sxx={sx} name="eye-lock-outline" size={16} color="grey.700" />
    </Box>
  );
});

LockIcon.displayName = 'LockIcon';
